import api from '../config/api';

export const getProjectDetail = id => {
    const res = api.get(`/iirsa_projects/${id}/details`);
    return res;
};
